import { type Customer, type LocalCustomer } from "#/Routes/Customers/CustomerTypes.ts";

/**
 * Convert a customer from IndexedDB to GraphQL
 */
export function convertFromIndexedDBToGraphQL(customer: LocalCustomer): Customer {
    return {
        id                  : customer.uuid,
        firstName           : customer.first_name,
        lastName            : customer.last_name,
        code                : customer.code,
        company             : customer.company,
        businessNumber      : customer.business_number,
        birthday            : customer.birthday as string,
        gender              : customer.gender,
        emails              : typeof customer.email === "string" ? customer.email.split(";") : [],
        allowMarketingEmails: null,
        fax                 : customer.billing.fax,
        phone               : customer.billing.phone,
        mobile              : customer.billing.mobile,
        website             : customer.billing.website,
        twitter             : customer.billing.twitter,
        facebook            : customer.billing.facebook,
        billing             : {
            addressStreet1 : customer.billing.address_street_1,
            addressStreet2 : customer.billing.address_street_2,
            addressSuburb  : customer.billing.address_suburb,
            addressCity    : customer.billing.address_city,
            addressPostcode: customer.billing.address_postcode,
            addressCountry : customer.billing.address_country,
            addressRegion  : customer.billing.address_state,
        },
        delivery: {
            addressStreet1 : customer.delivery.address_street_1,
            addressStreet2 : customer.delivery.address_street_2,
            addressSuburb  : customer.delivery.address_suburb,
            addressCity    : customer.delivery.address_city,
            addressPostcode: customer.delivery.address_postcode,
            addressCountry : customer.delivery.address_country,
            addressRegion  : customer.delivery.address_state,
        },
        invoiceMessage       : customer.invoice_message,
        comments             : customer.comments,
        customerGroup        : customer.customer_group_id,
        loyaltyEnabled       : customer.loyalty,
        loyaltyRate          : customer.loyalty_rate,
        loyaltyPoints        : customer.loyalty_points,
        disablePromotions    : customer.disable_promotions,
        priceList            : customer.pricelist_id,
        accountLimit         : customer.account_limit,
        currentOwing         : customer.current_owing,
        overrideCustomerGroup: customer.customer_group_id === null ? false : customer.override_customer_group,
        requireOrderReference: !!customer.require_order_reference,
    };
}

export type MarketingEmailRules = "optIn" | "optOut" | "notSpecified";
